/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Dialog_BookInputs */

const en_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a lesson with Mark`)
};

const es_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva una clase con Mark`)
};

const de_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterrichtsstunde bei Mark buchen`)
};

const zh_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约 Mark 的课程`)
};

const ar_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً مع Mark`)
};

const fr_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon avec Mark`)
};

const vi_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học với Mark`)
};

const sw_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya somo na Mark`)
};

const th_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียนกับ Mark`)
};

const bs_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite čas s Markom`)
};

const ja_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markのレッスンを予約する`)
};

const ko_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark와 레슨 예약하기`)
};

const pt_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula com o Mark`)
};

const it_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione con Mark`)
};

const sv_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion med Mark`)
};

const nl_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les bij Mark`)
};

const da_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion hos Mark`)
};

const nb_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en time hos Mark`)
};

const fi_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti Markilta`)
};

const pl_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję z Markiem`)
};

const ru_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на урок к тренеру Mark`)
};

const tr_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark ile ders ayırtın`)
};

const hi_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark के साथ पाठ बुक करें`)
};

const id_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran dengan Mark`)
};

const ms_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran dengan Mark`)
};

const cs_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte si lekci s Markem`)
};

const el_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα με τον Mark`)
};

const he_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו שיעור עם Mark`)
};

const af_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n les by Mark`)
};

const hu_method_dialog_book = /** @type {(inputs: Method_Dialog_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalj órát Markkal`)
};

/**
* | output |
* | --- |
* | "Book a lesson with Mark" |
*
* @param {Method_Dialog_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_dialog_book = /** @type {((inputs?: Method_Dialog_BookInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Dialog_BookInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_dialog_book(inputs)
	if (locale === "de") return de_method_dialog_book(inputs)
	if (locale === "zh") return zh_method_dialog_book(inputs)
	if (locale === "ar") return ar_method_dialog_book(inputs)
	if (locale === "fr") return fr_method_dialog_book(inputs)
	if (locale === "vi") return vi_method_dialog_book(inputs)
	if (locale === "sw") return sw_method_dialog_book(inputs)
	if (locale === "th") return th_method_dialog_book(inputs)
	if (locale === "bs") return bs_method_dialog_book(inputs)
	if (locale === "ja") return ja_method_dialog_book(inputs)
	if (locale === "ko") return ko_method_dialog_book(inputs)
	if (locale === "pt") return pt_method_dialog_book(inputs)
	if (locale === "it") return it_method_dialog_book(inputs)
	if (locale === "sv") return sv_method_dialog_book(inputs)
	if (locale === "nl") return nl_method_dialog_book(inputs)
	if (locale === "da") return da_method_dialog_book(inputs)
	if (locale === "nb") return nb_method_dialog_book(inputs)
	if (locale === "fi") return fi_method_dialog_book(inputs)
	if (locale === "pl") return pl_method_dialog_book(inputs)
	if (locale === "ru") return ru_method_dialog_book(inputs)
	if (locale === "tr") return tr_method_dialog_book(inputs)
	if (locale === "hi") return hi_method_dialog_book(inputs)
	if (locale === "id") return id_method_dialog_book(inputs)
	if (locale === "ms") return ms_method_dialog_book(inputs)
	if (locale === "cs") return cs_method_dialog_book(inputs)
	if (locale === "el") return el_method_dialog_book(inputs)
	if (locale === "he") return he_method_dialog_book(inputs)
	if (locale === "af") return af_method_dialog_book(inputs)
	if (locale === "hu") return hu_method_dialog_book(inputs)
	return en_method_dialog_book(inputs)
});